/**
 * How many cards are in a cell, for whatever describes it, such as a selection summary.
 *
 * Every card the cell has, not every card it has loaded. Those are different numbers on
 * a board that pages, and the loaded one changes under a reader every time another page
 * arrives.
 *
 * So the count the caller stated wins, floored at what is loaded, because a count from a
 * server can be stale and a count smaller than the cards already present is not true.
 * `-1` means the total is not known: the cell says it has more and never said how many.
 *
 * Shared rather than worked out where it is needed, so descriptions of the same cell
 * cannot drift apart.
 */
export function cardSetSize({
  totalCount,
  hasMoreItems,
  loaded,
}: {
  totalCount: number | undefined
  hasMoreItems: boolean
  loaded: number
}): number {
  if (totalCount !== undefined) return Math.max(totalCount, loaded)

  return hasMoreItems ? -1 : loaded
}
